import { DueDatesDTO } from 'pages/WellGuardian/WIR/wir.constants';

export type WellSchematic = {
  files?: File[] | null;
  tuwi?: string;
  schematic_type?: string;
  schematic_name?: string;
  user_id?: string;
  created_at?: string;
  LastSuccessfulRun?: string;
  folder_node?: string;
  update_date?: string;
};

export type WellSchematicOther = {
  adf_lastsuccessfulrun?: string;
  file_lastmodified?: string;
  schematic_name?: string;
  schematic_type?: string;
  tuwi?: string;
  sharepoint_link?: string;
};

export type WellInfo = {
  wellName?: string;
  wellType?: string;
  wellStatusDesc?: string;
  wellViewId?: string;
  completionAge?: string;
  integrityStatus?: string;
  lifeCycleAliasDesc?: string;
  slot?: string;
  site?: string;
  siteId?: string;
  mechanicalStatus?: string;
  wellOnlineStatus?: string;
  highlighted?: boolean;
  wellLogLink?: string;
  country?: string;
  oilSTB?: number;
  watSTB?: number;
  liqPotSTB?: number;
  gas?: number;
  gor?: number;
  wc?: number;
  waterInjection?: number;
  gasInjection?: number;
  eruptivity?: string;
  location?: string;
};

export type TargetInfo = {
  well_name?: string;
  well_type?: string;
  well_online_status?: string;
  highlighted?: boolean;
  wellview_id?: string;
  oil_stb_d?: number;
  wat_stb_d?: number;
  liq_pot_Stb_d?: number;
  gas_sm3?: number;
  gor?: number;
  wc?: number;
  winj_sm3_d?: number;
  ginj_sm3_d?: number;
};

export type WellInfoSort = {
  wellName?: string;
  wellType?: string;
  wellStatusDesc?: string;
  slot?: string;
};

export type TargetProducerSort = {
  well_name?: string;
  well_online_status?: string;
  oil_stb_d?: number;
  wat_stb_d?: number;
  liq_pot_Stb_d?: number;
  gas_sm3?: number;
  gor?: number;
  wc?: number;
};

export type TargetInjectorSort = {
  well_name?: string;
  well_online_status?: string;
  winj_sm3_d?: number;
  ginj_sm3_d?: number;
};

export type WellResources = {
  created_on?: string;
  user_added?: string;
  file_name?: string;
  link?: string;
  well_id?: string;
  id?: string;
};

export type WellReviews = {
  year: string;
  well_id: string;
  integrity_comment: string;
  current_jobs: string;
  future_jobs: string;
  notes: string;
  entry_date: string;
};

export type WellReviewsFetch = {
  year: string;
  wellId: string;
  integrityComment: string;
  currentJobs: string;
  futureJobs: string;
  notes: string;
  entryDate: string;
  id: string;
};

export type WirInfoFetch = {
  id?: string;
  phase_name: string;
  subtask_name: string;
  requirements: string;
  tips: string;
  country?: string;
};

export type IntegrityStatus = {
  reservoirType?: string;
  integrityStatusColor?: string;
  integrityDescription?: string;
  date?: string;
  wellViewId?: string;
};

export type AnnulusStatus = {
  wellBarrier?: string;
  annulusStatusColor?: string;
  annulusType?: string;
  date?: string;
  wellViewId?: string;
};

export type AnnuliGauge = {
  gaugeType?: string;
  wellViewId?: string;
  value?: number;
  high?: number;
  low?: number;
  highHigh?: number;
  lowLow?: number;
  lastUpdate?: string;
  maasp?: number;
  piLink?: string;
  tag?: string;
};

export type AnnuliGaugePlot = {
  wellViewId?: string | undefined;
  gaugeType?: string | undefined;
  lastUpdate?: string | null;
  statusColor?: string;
  isBlinking?: boolean;
  plotLayout?: any;
  plotData?: any;
  plotConfig?: any;
  tooltipContent?: any;
  piLink?: string;
  tag?: string;
};

export type LatestWellPotentials = {
  well_name?: string;
  wellview_id?: string;
  potential_date?: string;
  oil_stb_d?: number;
  wat_stb_d?: number;
  liq_pot_Stb_d?: number;
  winj_sm3_d?: number;
  ginj_sm3_d?: number;
  wc?: number;
  gas_sm3?: number;
  gor?: number;
  boe?: number;
};

export type ProductionRate = {
  production_date: string;
  wellview_id?: string;
  gas_rate_ksm3_d?: number;
  oil_bbl_d?: number;
  wat_bbl_d?: number;
  average_gas_rate?: number;
  average_oil_rate?: number;
  average_water_rate?: number;
};

export type WHTemperaturePressure = {
  production_date: string;
  wellview_id?: string;
  wht_degc?: string;
  whp_bar?: string;
  bhp_bara?: string;
};

export type Derogation = {
  site?: string;
  derogation_number: string;
  derogation_text: string;
  revision?: string;
  rule_paragraph?: string;
  author?: string;
  status?: string;
  start_date?: string;
  mitigation_measures?: string;
  expiry_date?: string;
  final_recommendation?: string;
  document_reference?: string;
  last_successful_run?: string;
};

export type Resources = {
  created_on?: string;
  user_added?: string;
  file_name?: string;
  link?: string;
  well_id?: string;
  id?: string;
};

export type KeyLinkD = {
  link_name: string;
  title: string;
  link: string;
  country: string;
  id: string;
};

export type Intervention = {
  estimated_gains?: string;
  eventDate?: string;
  wellview_id?: string;
  start_date: string;
  ws_job_type?: string;
  activity_objective?: string;
  activity_achievement?: string;
  planned_cost?: string;
  field_cost?: string;
  planned_duration?: string;
  actual_duration?: string;
  ws_status?: string;
  last_successful_run?: string;
  job_id?: string;
};

export type EstimatedGain = {
  estimated_gains?: string;
  isEdit?: boolean;
  method?: string;
  job_id: string;
  well_id: string;
  start_date: string;
};

export type DgsHse = {
  caseCategory: string;
  caseNumber: string;
  site?: string;
  caseStartDate?: string;
  caseEndDate?: string;
  caseStatus?: string;
  caseTitle?: string;
  equipmentInvolved?: string[];
  initialDomainOfConsequence?: string;
  initialRiskLevel?: string;
  initialRiskValue?: string;
  lastSuccessfulRun?: string;
  revision?: string;
  rule_paragraph?: string;
  mitigation_measures?: string;
  actionDetails: SynergiCaseActionDetails[];
  picDetails?: SynergiCasePicDetails[];
  residualDomainOfConsequence?: string;
  riskLevel?: string;
  riskType?: string;
  riskValue?: string;
  tuwi?: string;
};

export type Integrity = {
  tuwi?: string;
  Valve?: string;
  testDate?: string;
  testType?: string;
  tooltip1?: string;
  tooltip2?: string;
  valveStatus?: string;
};

export type SynergiCase = {
  site?: string;
  caseNumber: string;
  caseTitle?: string;
  equipmentInvolved: string[];
  riskType?: string;
  riskLevel?: string;
  initialRiskLevel?: string;
  riskValue?: string;
  initialRiskValue?: string;
  initialDomainOfConsequence?: string;
  residualDomainOfConsequence?: string;
  actionDetails: SynergiCaseActionDetails[];
  picDetails: SynergiCasePicDetails[];
};

export type SynergiCaseActionDetails = {
  id: number;
  action: string;
  picName: string;
  deadline: Date;
  progress: number;
};

export type SynergiCasePicDetails = {
  picName: string;
  nextDeadline?: Date;
  totalActionsToComplete: number;
};

export type AlertsCount = {
  activeAlerts?: number;
};

type SlotDTO = {
  row: string;
  col: string;
  value: string;
};

export type SiteLayout = {
  id: string;
  site?: string;
  columns?: string;
  rows?: string;
  slots?: SlotDTO[];
};

export type Acknowledged = {
  acknowledgedOn?: string;
  acknowledgedBy?: string;
  acknowledgedUserID?: string;
};

export type Notified = {
  notifiedOn?: string;
  notifiedEmail?: string;
  userID?: string;
};

export type PayloadPop = {
  assetName?: string;
  url?: string;
  opportunityTitle?: string;
  opportunityCreatedAt?: string;
  opportunityCode?: string;
  opportunityCampaign?: string;
  opportunityMethod?: string;
  status?: string;
  probabilityOfSuccess?: number;
  directCost?: number;
  productionPotential?: number;
  reservoirOrFormation?: string;
  operation?: string;
};

type PressureAnnuli = {
  pall?: number;
  pal?: number;
  pah?: number;
  pahh?: number;
  pressure?: number;
  state?: string;
  captureTime?: string;
};

export type PayloadWellBehaviour = {
  status: string;
  score: string;
  scoreDate: string;
};

export type PayloadAnnuli = {
  pressures: PressureAnnuli[];
};

export type Payload = PayloadPop | PayloadAnnuli | PayloadWellBehaviour;

export type Alert = {
  alertID: string;
  alertableObjectID?: string;
  alertDatetime?: string;
  priority?: AlertPriorities;
  parentID?: string;
  parentName?: string;
  alertType?: AlertTypes;
  alertDescription?: string;
  payload?: Payload;
  notified?: Notified[];
  acknowledged?: Acknowledged[];
  isActive?: boolean;
  autoArchived?: boolean;
};

export enum AlertPriorities {
  ALL = 'ALL',
  HIGH = 'HIGH',
  NORMAL = 'NORMAL',
  LOW = 'LOW',
}

export enum AlertTypes {
  ALL = 'ALL',
  POP = 'POP',
  ANNULI = 'ANNULI',
  WELLBEHAVIOUR = 'WELLBEHAVIOUR',
  ANNULITHRESHOLD = 'ANNULITHRESHOLD',
}

export enum AlertStatuses {
  ALL = 'ALL',
  ACTIVE = 'ACTIVE',
  AUTO_ARCHIVED = 'AUTO_ARCHIVED',
  PROCESSED = 'PROCESSED',
}

export enum CountryData {
  unitedKingdom = 'UNITED KINGDOM',
  denmark = 'Denmark',
  nigeria = 'NIGERIA',
  angola = 'ANGOLA',
  congo = 'CONGO',
  brazil = 'BRAZIL',
}

export const ALL_COUNTRIES_LIST = {
  data: [
    CountryData.unitedKingdom,
    CountryData.denmark,
    CountryData.nigeria,
    CountryData.angola,
    CountryData.congo,
    CountryData.brazil,
  ],
} as const;

export enum linkSelects {
  POWERBI = 'Power Bi Dashboard',
  DOCUMENT = 'Documentation',
  PIVISION = 'PI Vision Well Monitoring',
  OTHER = 'Other Well information',
}

export enum AssetsUk {
  ALL = 'ALL',
  NNS = 'NNS',
  CNS = 'CNS',
  WOS = 'WOS',
}

export enum AssetsNg {
  ALL = 'ALL',
  OML58 = 'OML58',
  OML99 = 'OML99',
  OML100 = 'OML100',
  OML102 = 'OML102',
  OML130 = 'OML130',
}

export enum AssetsDk {
  ALL = 'ALL',
  DAGMAR = 'DAGMAR',
  DAN = 'DAN',
  GORM = 'GORM',
  HALFDAN = 'HALFDAN',
  HARDLD = 'HARDLD',
  KRAKA = 'KRAKA',
  REGNAR = 'REGNAR',
  ROAR = 'ROAR',
  ROLF = 'ROLF',
  SKJOLD = 'SKJOLD',
  SVEND = 'SVEND',
  TYRAEAST = 'TYRAEAST',
  TYRASOUTHEAST = 'TYRASOUTHEAST',
  TYRAWEST = 'TYRAWEST',
  VALDEMAR = 'VALDEMAR',
}

export enum AssetsAg {
  ALL = 'ALL',
  B32 = 'B32',
  B17 = 'B17',
}

export enum AssetsCg {
  ALL = 'ALL',
  MOHOBILONDO = 'MOHOBILONDO',
  MOHONORD = 'MOHONORD',
  NKOSSA = 'NKOSSA',
  YANGA = 'YANGA',
  SENDJI = 'SENDJI',
}

export enum AssetsBr {
  ALL = 'ALL',
  CM541 = 'CM541',
  LAPA = 'LAPA',
}

export enum SitesUk {
  // ALL
  ALL = 'ALL',
  // NNS
  ALWYN_NORTH = 'ALWYN NORTH',
  DUNBAR = 'DUNBAR',
  GRYPHON = 'GRYPHON',
  SUBSEA_ALWYN = 'SUBSEA - ALWYN',
  SUBSEA_DUNBAR = 'SUBSEA - DUNBAR',
  SUBSEA_FORVIE = 'SUBSEA - FORVIE',
  SUBSEA_ISLAY = 'SUBSEA - ISLAY',
  SUBSEA_JURA = 'SUBSEA - JURA',
  SUBSEA_NUGGETS = 'SUBSEA - NUGGETS',
  // CNS
  CULZEAN = 'CULZEAN',
  ELGIN_A = 'ELGIN A',
  ELGIN_B = 'ELGIN B',
  FRANKLIN = 'FRANKLIN',
  WEST_FRANKLIN = 'WEST FRANKLIN',
  // WOS
  SUBSEA_EDRADOUR = 'SUBSEA - EDRADOUR',
  SUBSEA_GLENLIVET = 'SUBSEA - GLENLIVET',
  SUBSEA_LAGGAN = 'SUBSEA - LAGGAN',
  SUBSEA_TORMORE = 'SUBSEA - TORMORE',
}

export enum SitesNg {
  // ALL
  ALL = 'ALL',
  // OML130
  AKPO = 'AKPO',
  EGINA = 'EGINA',
  // OML 100
  AFIA = 'AFIA',
  EDIKAN = 'EDIKAN',
  IME = 'IME',
  ODUDU = 'ODUDU',
  // OML 102
  OFON = 'OFON',
  // OML 58
  IBEWA = 'IBEWA',
  OBAGI = 'OBAGI',
  EREMA = 'EREMA',
  // OML 99
  AMENAM = 'AMENAM',
  IKIKE = 'IKIKE',
}

export enum SitesDk {
  // ALL
  ALL = 'ALL',
  // DAGMAR
  DGA = 'DGA',
  // DAN
  DA = 'DA',
  DD = 'DD',
  DE = 'DE',
  DFA = 'DFA',
  DFB = 'DFB',
  DFE = 'DFE',
  DFF = 'DFF',
  // GORM
  GAN = 'GAN',
  GBN = 'GBN',
  GFN = 'GFN',
  // HALFDAN
  HBA = 'HBA',
  HBB = 'HBB',
  HCA = 'HCA',
  HDA = 'HDA',
  // HARDLD
  HEA = 'HEA',
  HWA = 'HWA',
  LUA = 'LUA',
  // KRAKA
  KRA = 'KRA',
  // REGNAR
  REA = 'REA',
  // ROAR
  ROA = 'ROA',
  // ROLF
  RFA = 'RFA',
  // SKJOLD
  SAN = 'SAN',
  SBN = 'SBN',
  // SVEND
  SVA = 'SVA',
  // TYRAEAST
  TEB = 'TEB',
  TEC = 'TEC',
  // TYRASOUTHEAST
  TSA = 'TSA',
  TSB = 'TSB',
  // TYRAWEST
  TWB = 'TWB',
  TWC = 'TWC',
  // VALDEMAR
  VAA = 'VAA',
  VAB = 'VAB',
  VBA = 'VBA',
}

export enum SitesAg {
  // ALL
  ALL = 'ALL',
  // B32
  KaomboNorth = 'Kaombo North',
  KaomboSouth = 'Kaombo South',
  // B17
  PAZFLOR = 'PAZFLOR',
  CLOV = 'CLOV',
  DALIA = 'DALIA',
  GIRASSOL = 'GIRASSOL',
}

export enum SitesCg {
  // ALL
  ALL = 'ALL',
  // MOHO-BILONDO
  ALIMA = 'ALIMA',
  LIKOUF = 'LIKOUF',
  TLPLIKOUF = 'TLPLIKOUF',
  // N'KOSSA
  NKF1 = 'NKF1',
  NKF2 = 'NKF2',
  // YANGA
  YAF1 = 'YAF1',
  YAF2 = 'YAF2',
  YAF3 = 'YAF3',
  YAF4 = 'YAF4',
  YAFP = 'YAFP',
  // SENDJI
  SEF1 = 'SEF1',
  SEF2 = 'SEF2',
  SEF3 = 'SEF3',
  SEF4 = 'SEF4',
  SEFP = 'SEFP',
}

export enum SitesBr {
  // ALL
  ALL = 'ALL',
  // C-M-541
  CM541 = 'CM541',
  // LAPA
  LAPASW = 'LAPASW',
  LAPANE = 'LAPANE',
}

export const ALL_ASSETS_WITH_SITES_UK = {
  [AssetsUk.ALL]: {
    asset: AssetsUk.ALL,
    sites: [SitesUk.ALL],
  },
  [AssetsUk.NNS]: {
    asset: AssetsUk.NNS,
    sites: [
      SitesUk.ALL,
      SitesUk.ALWYN_NORTH,
      SitesUk.DUNBAR,
      SitesUk.GRYPHON,
      SitesUk.SUBSEA_ALWYN,
      SitesUk.SUBSEA_DUNBAR,
      SitesUk.SUBSEA_FORVIE,
      SitesUk.SUBSEA_ISLAY,
      SitesUk.SUBSEA_JURA,
      SitesUk.SUBSEA_NUGGETS,
    ],
  },
  [AssetsUk.CNS]: {
    asset: AssetsUk.CNS,
    sites: [
      SitesUk.ALL,
      SitesUk.CULZEAN,
      SitesUk.ELGIN_A,
      SitesUk.ELGIN_B,
      SitesUk.FRANKLIN,
      SitesUk.WEST_FRANKLIN,
    ],
  },
  [AssetsUk.WOS]: {
    asset: AssetsUk.WOS,
    sites: [
      SitesUk.ALL,
      SitesUk.SUBSEA_EDRADOUR,
      SitesUk.SUBSEA_GLENLIVET,
      SitesUk.SUBSEA_LAGGAN,
      SitesUk.SUBSEA_TORMORE,
    ],
  },
} as const;

export const ALL_ASSETS_WITH_SITES_LIST_UK = Object.values(ALL_ASSETS_WITH_SITES_UK);

export const ALL_ASSETS_WITH_SITES_DK = {
  [AssetsDk.ALL]: {
    asset: AssetsDk.ALL,
    sites: [SitesUk.ALL],
  },
  [AssetsDk.DAGMAR]: {
    asset: AssetsDk.DAGMAR,
    sites: [SitesDk.ALL, SitesDk.DGA],
  },
  [AssetsDk.DAN]: {
    asset: AssetsDk.DAN,
    sites: [
      SitesDk.ALL,
      SitesDk.DA,
      SitesDk.DD,
      SitesDk.DE,
      SitesDk.DFA,
      SitesDk.DFB,
      SitesDk.DFE,
      SitesDk.DFF,
    ],
  },
  [AssetsDk.GORM]: {
    asset: AssetsDk.GORM,
    sites: [SitesDk.ALL, SitesDk.GAN, SitesDk.GBN, SitesDk.GFN],
  },
  [AssetsDk.HALFDAN]: {
    asset: AssetsDk.HALFDAN,
    sites: [SitesDk.ALL, SitesDk.HBA, SitesDk.HBB, SitesDk.HCA, SitesDk.HDA],
  },
  [AssetsDk.HARDLD]: {
    asset: AssetsDk.HARDLD,
    sites: [SitesDk.ALL, SitesDk.HEA, SitesDk.HWA, SitesDk.LUA],
  },
  [AssetsDk.KRAKA]: {
    asset: AssetsDk.KRAKA,
    sites: [SitesDk.ALL, SitesDk.KRA],
  },
  [AssetsDk.REGNAR]: {
    asset: AssetsDk.REGNAR,
    sites: [SitesDk.ALL, SitesDk.REA],
  },
  [AssetsDk.ROAR]: {
    asset: AssetsDk.ROAR,
    sites: [SitesDk.ALL, SitesDk.ROA],
  },
  [AssetsDk.ROLF]: {
    asset: AssetsDk.ROLF,
    sites: [SitesDk.ALL, SitesDk.RFA],
  },
  [AssetsDk.SKJOLD]: {
    asset: AssetsDk.SKJOLD,
    sites: [SitesDk.ALL, SitesDk.SAN, SitesDk.SBN],
  },
  [AssetsDk.SVEND]: {
    asset: AssetsDk.SVEND,
    sites: [SitesDk.ALL, SitesDk.SVA],
  },
  [AssetsDk.TYRAEAST]: {
    asset: AssetsDk.TYRAEAST,
    sites: [SitesDk.ALL, SitesDk.TEB, SitesDk.TEC],
  },
  [AssetsDk.TYRASOUTHEAST]: {
    asset: AssetsDk.TYRASOUTHEAST,
    sites: [SitesDk.ALL, SitesDk.TSA, SitesDk.TSB],
  },
  [AssetsDk.TYRAWEST]: {
    asset: AssetsDk.TYRAWEST,
    sites: [SitesDk.ALL, SitesDk.TWB, SitesDk.TWC],
  },
  [AssetsDk.VALDEMAR]: {
    asset: AssetsDk.VALDEMAR,
    sites: [SitesDk.ALL, SitesDk.VAA, SitesDk.VAB, SitesDk.VBA],
  },
} as const;

export const ALL_ASSETS_WITH_SITES_LIST_DK = Object.values(ALL_ASSETS_WITH_SITES_DK);

export const ALL_ASSETS_WITH_SITES_NG = {
  [AssetsNg.ALL]: {
    asset: AssetsNg.ALL,
    sites: [SitesNg.ALL],
  },
  [AssetsNg.OML58]: {
    asset: AssetsNg.OML58,
    sites: [SitesNg.ALL, SitesNg.IBEWA, SitesNg.OBAGI, SitesNg.EREMA],
  },
  [AssetsNg.OML99]: {
    asset: AssetsNg.OML99,
    sites: [SitesNg.ALL, SitesNg.AMENAM, SitesNg.IKIKE],
  },
  [AssetsNg.OML100]: {
    asset: AssetsNg.OML100,
    sites: [SitesNg.ALL, SitesNg.AFIA, SitesNg.EDIKAN, SitesNg.IME, SitesNg.ODUDU],
  },
  [AssetsNg.OML102]: {
    asset: AssetsNg.OML102,
    sites: [SitesNg.ALL, SitesNg.OFON],
  },
  [AssetsNg.OML130]: {
    asset: AssetsNg.OML130,
    sites: [SitesNg.ALL, SitesNg.AKPO, SitesNg.EGINA],
  },
} as const;

export const ALL_ASSETS_WITH_SITES_LIST_NG = Object.values(ALL_ASSETS_WITH_SITES_NG);

export const ALL_ASSETS_WITH_SITES_AG = {
  [AssetsAg.ALL]: {
    asset: AssetsAg.ALL,
    sites: [SitesAg.ALL],
  },
  [AssetsAg.B17]: {
    asset: AssetsAg.B17,
    sites: [SitesAg.ALL, SitesAg.PAZFLOR, SitesAg.CLOV, SitesAg.DALIA, SitesAg.GIRASSOL],
  },
  [AssetsAg.B32]: {
    asset: AssetsAg.B32,
    sites: [SitesAg.ALL, SitesAg.KaomboNorth, SitesAg.KaomboSouth],
  },
} as const;

export const ALL_ASSETS_WITH_SITES_LIST_AG = Object.values(ALL_ASSETS_WITH_SITES_AG);

export const ALL_ASSETS_WITH_SITES_CG = {
  [AssetsCg.ALL]: {
    asset: AssetsCg.ALL,
    sites: [SitesCg.ALL],
  },
  [AssetsCg.MOHOBILONDO]: {
    asset: AssetsCg.MOHOBILONDO,
    sites: [SitesCg.ALL, SitesCg.ALIMA],
  },
  [AssetsCg.MOHONORD]: {
    asset: AssetsCg.MOHONORD,
    sites: [SitesCg.ALL, SitesCg.LIKOUF, SitesCg.TLPLIKOUF],
  },
  [AssetsCg.NKOSSA]: {
    asset: AssetsCg.NKOSSA,
    sites: [SitesCg.ALL, SitesCg.NKF1, SitesCg.NKF2],
  },
  [AssetsCg.YANGA]: {
    asset: AssetsCg.YANGA,
    sites: [SitesCg.ALL, SitesCg.YAF1, SitesCg.YAF2, SitesCg.YAF3, SitesCg.YAF4, SitesCg.YAFP],
  },
  [AssetsCg.SENDJI]: {
    asset: AssetsCg.SENDJI,
    sites: [SitesCg.ALL, SitesCg.SEF1, SitesCg.SEF2, SitesCg.SEF3, SitesCg.SEF4, SitesCg.SEFP],
  },
} as const;

export const ALL_ASSETS_WITH_SITES_LIST_CG = Object.values(ALL_ASSETS_WITH_SITES_CG);

export const ALL_ASSETS_WITH_SITES_BR = {
  [AssetsBr.ALL]: {
    asset: AssetsBr.ALL,
    sites: [SitesBr.ALL],
  },
  [AssetsBr.CM541]: {
    asset: AssetsBr.CM541,
    sites: [SitesBr.ALL, SitesBr.CM541],
  },
  [AssetsBr.LAPA]: {
    asset: AssetsBr.LAPA,
    sites: [SitesBr.ALL, SitesBr.LAPASW, SitesBr.LAPANE],
  },
} as const;

export const ALL_ASSETS_WITH_SITES_LIST_BR = Object.values(ALL_ASSETS_WITH_SITES_BR);

export const getAssetFromSite = (searchSite: SiteType, country: string) => {
  if (country === CountryData.denmark) {
    return ALL_ASSETS_WITH_SITES_LIST_DK.find(asset =>
      asset.sites.map(site => String(site)).includes(searchSite),
    )?.asset;
  } else if (country === CountryData.nigeria) {
    return ALL_ASSETS_WITH_SITES_LIST_NG.find(asset =>
      asset.sites.map(site => String(site)).includes(searchSite),
    )?.asset;
  } else if (country === CountryData.angola) {
    return ALL_ASSETS_WITH_SITES_LIST_AG.find(asset =>
      asset.sites.map(site => String(site)).includes(searchSite),
    )?.asset;
  } else if (country === CountryData.congo) {
    return ALL_ASSETS_WITH_SITES_LIST_CG.find(asset =>
      asset.sites.map(site => String(site)).includes(searchSite),
    )?.asset;
  } else if (country === CountryData.brazil) {
    return ALL_ASSETS_WITH_SITES_LIST_BR.find(asset =>
      asset.sites.map(site => String(site)).includes(searchSite),
    )?.asset;
  } else {
    return ALL_ASSETS_WITH_SITES_LIST_UK.find(asset =>
      asset.sites.map(site => String(site)).includes(searchSite),
    )?.asset;
  }
};

export type AllWellsViewMode = 'grid' | 'list' | 'target';

export type WellBehaviour = {
  asset?: string;
  well?: string;
  date?: string;
  open?: number;
  gas?: number;
  oil?: number;
  water?: number;
  whp?: number;
  wht?: number;
  bhp?: number;
  bht?: number;
  wellViewId?: string;
  wellName?: string;
  displayCluster: number | null;
};

export type WellBehaviourClusterStats = {
  wellViewId: string | null;
  displayCluster: number | null;
  clusterDimensions: string | null;
  clusterEntriesCounts: number | null;
  dateMin: Date;
  dateMax: Date;
  gasMin: number | null;
  gasMax: number | null;
  oilMin: number | null;
  oilMax: number | null;
  waterMin: number | null;
  waterMax: number | null;
  whpMin: number | null;
  whpMax: number | null;
  whtMin: number | null;
  whtMax: number | null;
  bhpMin: number | null;
  bhpMax: number | null;
  bhtMin: number | null;
  bhtMax: number | null;
  chartName: string | null;
};

export type ClusterDetails = {
  clusterId: number | null;
  entriesCount: number;
};

export type SubscriptionType = {
  alertType: string;
  tuwi?: string;
};

export type SubscriptionDTO = {
  mobile: string | null;
  subscriptions: SubscriptionType[];
  alertableObjectSubscriptions?: string[];
};

export enum EventType {
  CHEMICAL_SCALE_REMOVAL_INFLOW = 'Chemical scale removal (Well Inflow)',
  CHEMICAL_SCALE_REMOVAL_OUTFLOW = 'Chemical scale removal (Well Outflow)',
  ACID_WASH = 'Acid Wash',
  CHOKE_UPGRADE = 'Choke up-grade',
  DEWATERING = 'Dewatering (foam injection)',
  FISHING = 'Fishing',
  MECHANICAL_SCRAPPING = 'Mechanical scrapping (e.g. wax)',
  MECHANICAL_SCALE_REMOVAL = 'Mechanical scale removal',
  REDEFINITION_OF_OPERATING_ENVELOP = 'Redefinition of operating envelop (Well outflow)',
  ROCKING_UNLOADING = 'Rock - Unloading',
  SCALE_INHIBITOR_INJECTION_DOWNHOLE = 'Scale inhibitor injection downhole',
  VELOCITY_STRING_INSTALLATION = 'Velocity string installation',
  TUBING_SIZE_OPTIMISATION = 'Tubing size optimisation',
  REPLACEMENT_OF_DHSV = 'Replacement of DHSV',
  XMAS_TREE_WELL_HEAD_REPAIR = 'X-mas tree - Well Head repair',
  REVISION_OF_A_PRODUCTION_CONTROL_LIMITATION = 'Revision of a production control limitation',
  PRODUCTION_EVENT = 'Production Event',
  OPERATIONAL_EVENT = 'Operational Event',
  DATA_ACQUISITION = 'Data Acquisition',
  OTHER = 'Other type',
}

export type WellBehaviourActivity = {
  id: string;
  tuwi: string;
  entryDate: string;
  eventDate: string;
  eventType: string;
  details: string;
  reportedBy: string;
  department?: string;
  start_date: string;
};

export type WellInfoForSite = Pick<WellInfo, 'wellName' | 'wellViewId'>;

export type OptionType = {
  label: string | JSX.Element;
  value: string;
};

export type R2SLink = {
  url: string;
  id?: string | null;
  title?: string | null;
  linkType?: string | null;
};

type WIRAssigneeUser = {
  roleName?: string;
  user?: string;
  userName?: string;
};

export enum WIRActionStatus {
  ACTIVE = 'ACTIVE',
  CLOSED = 'CLOSED',
  DELETED = 'DELETED',
}

export type WIRAction = {
  actionId?: number;
  actionName?: string;
  userActionee?: string;
  actioneeName?: string;
  state?: WIRActionStatus;
  freeText?: string;
  dateLastUpdated?: string;
  userLastUpdated?: string;
  responsibleName?: string;
  action?: string;
};

type WIRSignOffUserDetail = {
  userId?: string;
  userName?: string;
  date?: string;
};

export const isRoleIncludes = (
  roles: WIRTransverseRoles[] | undefined,

  permitRole: WIRTransverseRoles[] | undefined,
) => {
  const finalRole = [];

  if (roles !== undefined && permitRole !== undefined) {
    permitRole.forEach((role: WIRTransverseRoles) => {
      if (roles.includes(role)) {
        finalRole.push(role);
      }
    });
  }

  return finalRole.length !== 0;
};

export type WIRSignOffs = {
  technicalWirOriginator?: WIRSignOffUserDetail;
  technicalWirAssetRep?: WIRSignOffUserDetail;
  technicalWirGSRLeader?: WIRSignOffUserDetail;
  technicalWirInterventionEngineer?: WIRSignOffUserDetail;
  finalWirAssetManager?: WIRSignOffUserDetail;
  finalWirGsrManager?: WIRSignOffUserDetail;
  finalWirHeadOfReservoir?: WIRSignOffUserDetail;
  finalWirPerformanceLead?: WIRSignOffUserDetail;
  finalWirWscLeader?: WIRSignOffUserDetail;
  finalWirSiteSupportLeader?: WIRSignOffUserDetail;
  interventionCloseOutFinalSignOff?: WIRSignOffUserDetail;
};

export enum WIRSignOffType {
  TECHNICAL_WIR_ORIGINATOR = 'TECHNICAL_WIR_ORIGINATOR',
  TECHNICAL_WIR_ASSET_REP = 'TECHNICAL_WIR_ASSET_REP',
  TECHNICAL_WIR_INTERVENTION_ENGINEER = 'TECHNICAL_WIR_INTERVENTION_ENGINEER',
  FINAL_WIR_ASSET_MANAGER = 'FINAL_WIR_ASSET_MANAGER',
  FINAL_WIR_GSR_MANAGER = 'FINAL_WIR_GSR_MANAGER',
  TECHNICAL_WIR_GSR = 'TECHNICAL_WIR_GSR',
  FINAL_WIR_HEAD_OF_RESERVOIR = 'FINAL_WIR_HEAD_OF_RESERVOIR',
  FINAL_WIR_PERFORMANCE_LEAD = 'FINAL_WIR_PERFORMANCE_LEAD',
  FINAL_WIR_WSC_LEADER = 'FINAL_WIR_WSC_LEADER',
  FINAL_WIR_SITE_SUPPORT_LEADER = 'FINAL_WIR_SITE_SUPPORT_LEADER',
  INTERVENTION_CLOSE_OUT_FINAL_SIGN_OFF = 'INTERVENTION_CLOSE_OUT_FINAL_SIGN_OFF',
}

export type WIRSignOffDTO = {
  userId?: string;
  userName?: string;
  signOffType?: WIRSignOffType;
};

export enum WIRTransverseRoles {
  READ_ONLY_WIR_USER = 'READ_ONLY_WIR_USER',
  WIR_USER = 'WIR_USER',
  WIR_SUPER_USER = 'WIR_SUPER_USER',
  WIR_DEVELOPER = 'WIR_DEVELOPER',
  INTERVENTION_SUPERINTENDANT = 'INTERVENTION_SUPERINTENDANT',
  INTERVENTION_LEAD_ENGINEER = 'INTERVENTION_LEAD_ENGINEER',
  INTERVENTION_ENGINEER = 'INTERVENTION_ENGINEER',
  WS_TECHNICAL_ASSISTANT = 'WS_TECHNICAL_ASSISTANT',
  ASSET_FOCAL_POINT = 'ASSET_FOCAL_POINT',
  ASSET_MANAGER = 'ASSET_MANAGER',
  ASSET_BUDGET_HOLDER = 'ASSET_BUDGET_HOLDER',
  GSR_MANAGER = 'GSR_MANAGER',
  GSR_FIELD_LEADER = 'GSR_FIELD_LEADER',
  HEAD_OF_RESERVOIR = 'HEAD_OF_RESERVOIR',
  COMPLETIONS_LEAD = 'COMPLETIONS_LEAD',
  WSC_LEADER = 'WSC_LEADER',
  PERFORMANCE_LEAD = 'PERFORMANCE_LEAD',
  DW_MANAGER = 'DW_MANAGER',
  OFFSHORE_INTERVENTION_SUPERVISOR = 'OFFSHORE_INTERVENTION_SUPERVISOR',
  SMART_ROOM_FOCAL_POINT = 'SMART_ROOM_FOCAL_POINT',
  COST_ADMIN = 'COST_ADMIN',
  CHEMIST = 'CHEMIST',
  PLANNER = 'PLANNER',
  JV_REP = 'JV_REP',
  WELL_EXAMINER = 'WELL_EXAMINER',
  MAILING_LIST = 'MAILING_LIST',
  WONS = 'WONS',
  WELL_REVIEW_USER = 'WELL_REVIEW_USER',
}

export type WIRUser = {
  id?: string;
  userId?: string;
  userName?: string;
  emailAddress?: string;
  roles?: WIRTransverseRoles[];
  assets?: any;
  country?: CountryData;
};

export type WIRAttachment = {
  attachmentUrl?: string;
  attachmentTitle?: string;
};

export type WIRComment = {
  commentText?: string;
  userAuthor?: string;
  dateLastUpdated?: string;
};

export type CommentWIR = {
  id?: string;
  comment_text?: string;
  user_author?: string;
  date_last_updated?: string;
  wir_number?: string;
};

export type CommentEditWIR = {
  comment_text?: string;
  date_last_updated?: string;
};

type WIRMeetingAttendeeDTO = {
  userId?: string;
  userName?: string;
  roles?: WIRTransverseRoles[];
};

export type WIRSection = {
  isTicked?: boolean;
  lastUpdatedDate?: string;
  completedDate?: string;
  assignedTo?: string;
  completedBy?: string;
  isVisible?: boolean;
  isRequired?: boolean;
  isCriticalSensitiveJob?: boolean;
  reason?: string;
  sectionCompleteConfirmation?: boolean;
  attachments?: WIRAttachment[];
  comments?: WIRComment[];
  attendees?: WIRMeetingAttendeeDTO[];
  afeGhg?: string;
  afeEmission?: string;
};

export type WIRSectionDTO = WIRSection & {
  section: string;
  phase: string;
};

export type WIRSChecksActionsSectionDTO = WIRSectionDTO & {
  actions: WIRAction[];
  checks: WIRCheck[];
};

export type WIRManagerialSummary = WIRSection & {
  shortFalls?: string;
  shortFall?: string;
  interventionDuration?: string;
  posOfGains?: string;
  boePriceAssumed?: string;
  afeCost?: string;
  technicalPos?: string;
  payBack?: string;
  ghgEmission?: string;
  productionGains?: string;
  productionSafeguarded?: string;
};

export type WIRInitialRequestInformation = WIRSection & {
  interventionTitle?: string;
  objectives?: string;
  originatorName?: string;
  originatorId?: string;
  interventionDate?: string;
  interventionType?: string[];
  interventionComplexity?: string;
  initialBudget?: string;
  productGains?: string;
  productionSafeguarded?: string;
  expectedInterventionDuration?: number;
  ghgEmission?: string;
  budgetClassJustification?: string;
  budgetClassification?: string;
};

export type WIROrganiseKickOffMeeting = WIRSection & {
  meetingDate?: string;
  userIdInterventionEngineer?: string;
  userNameInterventionEngineer?: string;
  kickOffMeetingAttendees?: WIRMeetingAttendeeDTO[];
};

export type WIRWellInformation = WIRSection & {
  hudDate?: string;
  lastHud?: string;
  hudTag?: string;
  prodDataDate?: string;
  choke?: string;
  gasRate?: string;
  waterRate?: string;
  oilRate?: string;
  GOR?: string;
  exportRate?: string;
  co2?: string;
  whsip?: string;
  whfp?: string;
  whft?: string;
  mewhp?: string;
  bht?: string;
  bhp?: string;
  fracPressure?: string;
  h2s?: string;
};

export enum YesNoList {
  YES = 'Yes',
  NO = 'No',
}

export enum WIRResourceTeam {
  WELL_INTERVENTION_TEAM = 'Well Intervention Team',
  PLATFORM_SUPPORT_TEAM = 'Platform Support Team',
}

export type WIRResource = {
  company?: string;
  team?: WIRResourceTeam;
  numOfPersonnel?: string;
  position?: string;
  role?: string;
  dayAndNights?: YesNoList;
};

export type WIREquipmentIdentification = WIRSection & {
  resources?: WIRResource[];
};

type WIRSections = {
  initialRequestInformation?: WIRInitialRequestInformation;
  organiseKickOffMeeting?: WIROrganiseKickOffMeeting;
  reviewWellHistory?: WIRSection;
  wellInformation?: WIRWellInformation;
  reviewChecklistActions?: WIRSection;
  signOffTechnicalWIR?: WIRSection;
  vendorEngagementSelection?: WIRSection;
  equipmentIdentification?: WIREquipmentIdentification;
  equipmentProcurement?: WIRSection;
  interventionStrategyDefined?: WIRSection;
  technicalReviewRiskReward?: WIRSection;
  technicalPosEstabilished?: WIRSection;
  afeCreated?: WIRSection;
  afeGhgEmission?: WIRSection;
  chemicalChecksTopsideMetallurgy?: WIRSection;
  crossChemicalCompatibility?: WIRSection;
  chemicalChecksReservoir?: WIRSection;
  chemicalChecksFormation?: WIRSection;
  chemicalChecksTopsideEffluent?: WIRSection;
  chemicalChecksFlowBack?: WIRSection;
  cefasRegistration?: WIRSection;
  sandingStudy?: WIRSection;
  finalWirSignOff?: WIRSection;
  managerialSummary?: WIRManagerialSummary;
  afeApproved?: WIRSection;
  partnersNotified?: WIRSection;
  updateChemicalPermits?: WIRSection;
  wonsApplication?: WIRSection;
  hseNotification?: WIRSection;
  fpsWaiver?: WIRSection;
  bridgingSimopsDocuments?: WIRSection;
  // draftProgrammePrepared?: WIRSection; //Commented on latest requirement
  wellInterventionOnPaper?: WIRSection;
  perforationProforma?: WIRSection;
  equipmentPreparation?: WIRSection;
  programmeReview?: WIRSection;
  hqTechnicalReview?: WIRSection;
  programmeDistributed?: WIRSection;
  costSheetPrepared?: WIRSection;
  vesselApplication?: WIRSection;
  assetStatusCheck?: WIRSection;
  equipmentPersonnelSite?: WIRSection;
  capPortalUpdates?: WIRSection;
  lessonsCaptured?: WIRSection;
  prepareTpfr?: WIRSection;
  wellHandoverIntervStart?: WIRSection;
  emergencyDrill?: WIRSection;
  wellHandoverBackToOpsEnd?: WIRSection;
  // liveWcrsReporting?: WIRSection;   //Removed as per updated requirement
  livePerformanceTracking?: WIRSection;
  interventionRetrospective?: WIRSection;
  interventionSingleSlideSummary?: WIRSection;
  capPortalCloseOut?: WIRSection;
  wonsCloseOut?: WIRSection;
  signOffWcrs?: WIRSection;
  completionSchematicUpdate?: WIRSection;
  wellSchematicUpdate?: WIRSection;
  emtraxUpdate?: WIRSection;
  interventionWellDataStored?: WIRSection;
  vendorCloseOut?: WIRSection;
  interventionPerformanceCloseOut?: WIRSection;
  assetCloseOutPresentation?: WIRSection;
  rex?: WIRSection;
  costConsolidationCloseOut?: WIRSection;
  endOfInterventionReport?: WIRSection;
  hqTechnicalfinalInterventionSignOff?: WIRSection;
  actualGhgEmission?: WIRSection;
  interventionJustification?: WIRSection;
  regularPermitsRequested?: WIRSection;
  regularPermitsReceived?: WIRSection;
  closeOutChecklists?: WIRSection;
};

type WIRStep = {
  dateStarted?: string;
  dueDate?: string;
  completedDate?: string;
  assignedTo?: string;
  sections?: Partial<WIRSections>;
};

type WIRPhases = {
  // United Kingdom
  wirCreated?: WIRStep;
  kickOffTechnicalWir?: WIRStep;
  engineeringWork?: WIRStep;
  finalWir?: WIRStep;
  finalPreparation?: WIRStep;
  interventionOperation?: WIRStep;
  interventionCloseOut?: WIRStep;
  reactiveScope?: WIRStep;
  // Denmark
  stageGate1?: WIRStep;
  stageGate2?: WIRStep;
  stageGate3?: WIRStep;
  stageGate4?: WIRStep;
  stageGate5?: WIRStep;
  // Nigeria
  ngFinalPreparation?: WIRStep;
  ngInterventionOperation?: WIRStep;
  ngInterventionCloseOut?: WIRStep;
  // Congo
  cgWirCreated?: WIRStep;
  cgKickOffTechnicalWir?: WIRStep;
  cgEngineeringWork?: WIRStep;
  cgFinalWir?: WIRStep;
  cgFinalPreparation?: WIRStep;
  cgInterventionOperation?: WIRStep;
  cgInterventionCloseOut?: WIRStep;
};

export enum WIRCheckSection {
  GENERIC = 'GENERIC',
  PRODUCTION_AND_RESERVOIR = 'PRODUCTION_AND_RESERVOIR',
  PUMPING_OPERATION = 'PUMPING_OPERATION',
  PERFORATIONS = 'PERFORATIONS',
  WELL_STIMULATION = 'WELL_STIMULATION',
}

export type WIRCheck = {
  checkId?: number;
  state?: string;
  freeText?: string;
  checkSection?: WIRCheckSection;
  dateLastUpdated?: string;
  userLastUpdated?: string;
  disabledCheck?: boolean;
};

export type WIRChecklist = {
  generic?: WIRCheck[];
  production_and_reservoir?: WIRCheck[];
  pumping_operation?: WIRCheck[];
  perforations?: WIRCheck[];
  well_stimulation?: WIRCheck[];
};

export enum WirPauseStates {
  PAUSED = 'PAUSED',
  ARCHIVED = 'ARCHIVED',
  ACTIVE = 'ACTIVE',
}

export type PausePersistenceDTO = {
  newPauseStatus?: WirPauseStates;
  newInterventionDate?: string;
  pauseReason?: string;
  estimatedWorkRemaining?: string;
};

export type PauseCalculateDTO = {
  newInterventionDate?: string;
  estimatedWorkRemaining?: string;
};

export type WIRListPresentation = {
  wirNumber?: string;
  interventionTitle?: string;
  well?: string;
  dueDateStatus?: string;
  interventionType?: string[];
  startDate?: string;
  interventionDate?: string;
  state?: string;
  userNameInterventionEngineer?: string;
  lastUpdatedDate?: string;
  wellId?: string;
  asset?: string;
  site?: string;
  pausedState?: WirPauseStates;
  country?: CountryData;
};

type ScheduleWIRPhase = {
  phaseName?: string;
  dateStarted?: string;
  dateDue?: string;
  dateCompleted?: string;
};

type ScheduleWIRPause = {
  date_intervention_old?: string;
  date_intervention_start?: string;
  date_pause_start?: string;
  pause_event?: string;
  pause_reason?: string;
  user_paused?: string;
  _id?: string;
};

export type ScheduleWIR = {
  wirNumber?: string;
  well?: string;
  dueDateStatus?: string;
  startDate?: string;
  interventionDate?: string;
  state?: string;
  pausedState?: WirPauseStates;
  asset?: string;
  site?: string;
  interventionType?: string[];
  interventionTitle?: string;
  interventionEngineer?: string;
  isUnplannedReactiveScope?: boolean;
  lastUpdatedDate?: string;
  phases?: ScheduleWIRPhase[];
  pauses?: ScheduleWIRPause[];
};

export type pauses = {
  dateInterventionNew: string;
  dateInteventionOld: string;
  datePauseEstimate: string;
  datePauseEnd: string;
  datePauseStart: string;
  pauseEvent: string;
  userPaused: string;
  userUnpaused: string;
};

export type WIR = {
  id?: string;
  wellId?: string;
  wirNumber?: string;
  dueDateStatus?: string;
  state?: string;
  expectedEngineeringTime?: number;
  isUnplannedReactiveScope?: boolean;
  pausedState?: WirPauseStates;
  pauses?: pauses[];
  asset?: string;
  startDate?: string;
  lastUpdatedDate?: string;
  lastUpdatedBy?: string;
  endDate?: string;
  well?: string;
  site?: string;
  assignees?: WIRAssigneeUser[];
  phases?: WIRPhases;
  signOffs?: WIRSignOffs;
  actions?: WIRAction[];
  checklist?: WIRChecklist;
  country?: string;
};

export type pendingPhase = {
  userName?: string;
  userId?: string;
  pendingCheckListCount: number;
  pendingSubtaskCount: number;
};

export type riskStatus = {
  country?: string;
  dueDateStatus?: string;
  pendingAction: pendingPhase[];
  state?: string;
  wirNumber?: string;
  userNameInterventionEngineer?: string;
  well?: string;
};

export type WIRDTO = Pick<
  WIRInitialRequestInformation,
  | 'interventionComplexity'
  | 'interventionType'
  | 'originatorId'
  | 'originatorName'
  | 'interventionTitle'
  | 'objectives'
  | 'interventionDate'
> & {
  wellId?: string;
  well?: string;
  expectedEngineeringTime?: number;
  isUnplannedReactiveScope?: boolean;
};

export enum WIRPhaseTypes {
  WIR_CREATED = 'WIR_CREATED',
  KICK_OFF_TECHNICAL_WIR = 'KICK_OFF_TECHNICAL_WIR',
  ENGINEERING_WORK = 'ENGINEERING_WORK',
  FINAL_WIR = 'FINAL_WIR',
  FINAL_PREPARATION = 'FINAL_PREPARATION',
  INTERVENTION_OPERATION = 'INTERVENTION_OPERATION',
  REACTIVE_SCOPE = 'REACTIVE_SCOPE',
  INTERVENTION_CLOSE_OUT = 'INTERVENTION_CLOSE_OUT',
  INTERVENTION_COMPLETE = 'INTERVENTION_COMPLETE',
  STAGE_GATE_1 = 'STAGE_GATE_1',
  STAGE_GATE_2 = 'STAGE_GATE_2',
  STAGE_GATE_3 = 'STAGE_GATE_3',
  STAGE_GATE_4 = 'STAGE_GATE_4',
  STAGE_GATE_5 = 'STAGE_GATE_5',
  NG_FINAL_PREPARATION = 'NG_FINAL_PREPARATION',
  NG_INTERVENTION_OPERATION = 'NG_INTERVENTION_OPERATION',
  NG_INTERVENTION_CLOSE_OUT = 'NG_INTERVENTION_CLOSE_OUT',
  PAUSED_STATE = 'PAUSES',
  CG_WIR_CREATED = 'CG_WIR_CREATED',
  CG_KICK_OFF_TECHNICAL_WIR = 'CG_KICK_OFF_TECHNICAL_WIR',
  CG_ENGINEERING_WORK = 'CG_ENGINEERING_WORK',
  CG_FINAL_WIR = 'CG_FINAL_WIR',
  CG_FINAL_PREPARATION = 'CG_FINAL_PREPARATION',
  CG_INTERVENTION_OPERATION = 'CG_INTERVENTION_OPERATION',
  CG_INTERVENTION_CLOSE_OUT = 'CG_INTERVENTION_CLOSE_OUT',
}

export type ChecklistQuestion = {
  check_id: number;
  check_name: string;
  check_responsible: string;
  yes_action: string | null;
  no_action: string | null;
};

export type ChecklistQuestions = {
  generic: ChecklistQuestion[];
  production_and_reservoir: ChecklistQuestion[];
  pumping_operation: ChecklistQuestion[];
  perforations: ChecklistQuestion[];
  well_stimulation: ChecklistQuestion[];
};

export type CheckScheduleResponseDTO = {
  dueDateBehindSchedule?: boolean;
};

export type CheckScheduleCalculateDTO = {
  ENGINEERING_WORK?: string;
  FINAL_PREPARATION?: string;
  FINAL_WIR?: string;
  INTERVENTION_CLOSE_OUT?: string;
  INTERVENTION_OPERATION?: string;
  KICK_OFF_TECHNICAL_WIR?: string;
  PAUSE_END: string;
  PAUSE_START?: string;
  WIR_CREATED?: string;
};

export type SiteType = SitesUk | SitesDk | SitesNg | SitesAg | SitesCg | SitesBr;

export type AssetType = AssetsUk | AssetsDk | AssetsNg | AssetsAg | AssetsCg | AssetsBr;

export type AssetTypeOf =
  | typeof AssetsUk
  | typeof AssetsDk
  | typeof AssetsNg
  | typeof AssetsAg
  | typeof AssetsCg
  | typeof AssetsBr;

export enum LocalAuthorities {
  LOCAL_AUTHORITIES = 'Local Authorities',
  WONS = 'WONS',
}

export enum WELL_STATUS_DESCS {
  HEALTHY = 'Healthy well, no or minor issue',
  MINOR_MEASURES = 'One barrier envelope degraded, the other intact',
  MAJOR_MEASURES = 'One envelope failed, one intact (or two degraded)',
  NOT_ACCEPTABLE = 'One barrier envelope failure, the other degraded',
}

export enum WELL_STATUS_UPDATE {
  HEALTHY = 'Compliant: "Healthy well, no or minor issue"',
  MINOR_MEASURES = 'Minor Defect: "One barrier envelope degraded, the other intact"',
  MAJOR_MEASURES = 'Major Defect: "One envelope failed, one intact (or two degraded)"',
  NOT_ACCEPTABLE = 'Non Compliant: "One barrier envelope failure, the other degraded"',
}

export enum FINAL_RECOMMENDATION_TYPES {
  NOT_RECOMMENDED = 'Not Recommended',
  RECOMMENDED = 'Recommended',
  CANCELED = 'Canceled',
}

export enum WELL_STATUS {
  ABANDONNED_PHASE_1 = 'Abandoned Phase 1',
  ABANDONNED_PHASE_2 = 'Abandoned Phase 2',
  ABANDONNED_PHASE_3 = 'Abandoned Phase 3',
  COMPLETED_OPERATING = 'Completed (Operating)',
  COMPLETED_SHUT_IN = 'Completed (Shut In)',
  COMPLETED_SHUT_IN_ = 'Completed(Shut-In)',
  COMPLETED_CYCLE = 'Completed(Cycle)',
  COMPLETED_ACTIVE = 'Completed(Active)',
  DRILLING = 'Drilling',
  PLANNED = 'Planned',
  PLUGGED = 'Plugged',
  SUSPENDED = 'Suspended',
  PROGRESS = 'Progress(Shut-In)',
  SUSPENDED_COMPLETED = 'Suspended completed',
  SUSPENDED_COMPLETED_SHUT_IN = 'Suspended completed(Shut-In)',
  SUSPENDED_SHUT_IN = 'Suspended(Shut-In)',
  TEMPORARY_ABANDONED = 'Temporary abandoned',
  TEMPORARY_ABANDONED_SHUT_IN = 'Temporary abandoned(Shut-In)',
  TEMPORARY_ABANDONED_AB1 = 'Temporary abandoned(AB1)',
  TEMPORARY_ABANDONED_AB2 = 'Temporary abandoned(AB2)',
  PERMANENTLY_ABANDONED = 'Permanently Abandoned',
  PERMANENTLY_ABANDONED_SHUT_IN = 'Permanently Abandoned(Shut-In)',
}

export type WSType = {
  wsNumber: string;
  description: string;
  startDate: string;
  endDate: string;
  duration: string;
  checked: boolean;
};

export type WSExcelType = {
  delete_record_flag?: string;
  end_date: string;
  resource_list: string;
  start_date: string;
  status_code?: string;
  task_code: string;
  task_name: string;
  wbs_id: string;
};

export enum ActionsList {
  FINAL_PREPARATION_HSE_NOTIFICATION = 'FINAL_PREPARATION.HSE_NOTIFICATION',
  FINAL_PREPARATION_WONS_APPLICATION = 'FINAL_PREPARATION.WONS_APPLICATION',
  FINAL_PREPARATION_REGULAR_PERMITS_REQUESTED = 'FINAL_PREPARATION.REGULAR_PERMITS_REQUESTED',
  FINAL_PREPARATION_UPDATE_CHEMICAL_PERMITS = 'FINAL_PREPARATION.UPDATE_CHEMICAL_PERMITS',
  FINAL_PREPARATION_PERFORATION_PROFORMA = 'FINAL_PREPARATION.PERFORATION_PROFORMA',
  ENGINEERING_WORK_CHEMICAL_CHECKS = 'ENGINEERING_WORK.CHEMICAL_CHECKS',
  ENGINEERING_WORK_CROSS_CHEMICAL_COMPATIBILITY = 'ENGINEERING_WORK.CROSS_CHEMICAL_COMPATIBILITY',
  ENGINEERING_WORK_CHEMICAL_CHECKS_TOPSIDES = 'ENGINEERING_WORK.CHEMICAL_CHECKS_TOPSIDES',
  ENGINEERING_WORK_CHEMICAL_CHECKS_RESERVOIR = 'ENGINEERING_WORK.CHEMICAL_CHECKS_RESERVOIR',
  ENGINEERING_WORK_CHEMICAL_CHECKS_FORMATION = 'ENGINEERING_WORK.CHEMICAL_CHECKS_FORMATION',
  ENGINEERING_WORK_CEFAS_REGISTRATION = 'ENGINEERING_WORK.CEFAS_REGISTRATION',
  ENGINEERING_WORK_SANDING_STUDY = 'ENGINEERING_WORK.SANDING_STUDY',
  ENGINEERING_WORK_CHEMICAL_CHECKS_FLOWBACK = 'ENGINEERING_WORK.CHEMICAL_CHECKS_FLOWBACK',
  ENGINEERING_WORK_EQUIPMENT_PROCUREMENT = 'ENGINEERING_WORK.EQUIPMENT_PROCUREMENT',
  FINAL_PREPARATION_FPS_WAIVER = 'FINAL_PREPARATION.FPS_WAIVER',
  FINAL_PREPARATION_BRIDGING_DOCUMENTS = 'FINAL_PREPARATION.BRIDGING_DOCUMENTS',
  FINAL_PREPARATION_VESSEL_APPLICATION = 'FINAL_PREPARATION.VESSEL_APPLICATION',
}

export type PayloadArrayFormat = WIRSectionDTO[] | DueDatesDTO[];
